import _version from './../version_1on1navi_web.js'
import _LiteMode from './../mode_1on1navi_web.js'
import Vue from 'vue'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './stores/store'
import { sync } from 'vuex-router-sync'
import firebaseApp from './firebase-setup'
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'
import Vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2'
import VueI18n from 'vue-i18n'
import VueObserveVisibility from 'vue-observe-visibility'
import ToggleButton from 'vue-js-toggle-button'
import scrollTo from 'vue-scrollto'
// import VueCytoscape from 'vue-cytoscape'
// Vue.use(VueCytoscape)
Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(Croppa)
Vue.use(Vuelidate)
Vue.use(VueSweetalert2)
Vue.use(VueI18n)
Vue.use(VueObserveVisibility)
Vue.use(ToggleButton)
Vue.use(scrollTo)

Vue.config.productionTip = false

Vue.prototype.$firebase = firebaseApp
export const db = firebaseApp.database()
export const storage = firebaseApp.storage()
export const transLanguage = function (locale) { i18n.locale = locale }
export const language = (window.navigator && window.navigator.languages && window.navigator.languages[0]) ||
                                                  window.navigator.language ||
                                                  window.navigator.userLanguage ||
                                                  window.navigator.browserLanguage
let locale
let checkLocalStorage = ''
console.log('window.navigator::', window.navigator)
console.log('window language::', language)
try {
  if (window.localStorage) {
    checkLocalStorage = true
  } else {
    checkLocalStorage = false
  }
} catch (e) {
  checkLocalStorage = false
  console.log('storage error::', e)
}
console.log('checkLocalStorage::', checkLocalStorage)
if (checkLocalStorage && localStorage.language) {
  locale = localStorage.language
  console.log('localStorage::', localStorage)
} else {
  if (language === 'ja-JP') locale = 'ja'
  else if (language === 'en-US') locale = 'en'
  else if (language === 'zh-TW') locale = 'zh_tr'
  else if (!language) locale = 'ja'
  else if (locale !== 'ja' && locale !== 'en' && locale !== 'zh_tr') locale = 'ja'
  else locale = language
  if (checkLocalStorage) {
    localStorage.setItem('language', locale)
    console.log('localStorage::', localStorage)
  }
  console.log('set locale::', locale)
}
// export const settings = _settings
let liteMode = true
if (_LiteMode === 0) {
  liteMode = Boolean(!(location.hostname.split('.').reverse()[2] === 'app')) // lite処理
} else if (_LiteMode === 2) {
  liteMode = false
}
console.log('mode', liteMode ? 'lite' : 'normal')
export { liteMode }
export const routePath = liteMode ? 'one' : 'okr'
export const routeRegistPath = liteMode ? 'OneList' : 'OkrList'
export const settings = require('../../storage/_config/web_settings.json')
export const progress = settings.progress
export const content1on1 = {
  content1on1: settings.content1on1,
  notes1on1: settings.notes1on1
}
export const about = {
  companyName: settings.about.companyName,
  appVersion: _version
}
export const stamps = settings.stamps
export const stampsurl = settings.webview
export const noticeSettingsExport = {
  settingInfo: settings.settingInfo,
  settingKey: settings.settingKey
}
export const licenseAgreement = settings.licenseAgreement
export const willysm = liteMode ? settings.extApps.willysm.lite.web : settings.extApps.willysm.std.web

export const i18n = new VueI18n({
  locale: locale, // デフォルト言語はjaにしておくが、ブラウザの言語を拾ってきてここに入れる => 言語変更されたら書き換える
  messages: settings.i18n
})
export const onFocus = document.hasFocus() // TODO: こいつ必要？何やってるの？

sync(store, router)
console.log('main.js:initUser')
store.dispatch('initUser')

let initPromise = []
let app
firebaseApp.auth().onAuthStateChanged(function (user) {
  console.log('main.js:onAuthStateChanged:', user)
  if (!user || user) {
    console.log('cookies:', document.cookie)
    let c = document.cookie.split(';').map(x => { return x.trim().split('=') })
    let cf = c.some(x => {
      let f = (x[0] === 'CustomToken1on1navi')
      console.log('authType:', settings.authType)
      console.log('authTypes:', settings.authTypes)
      if (f && (settings.authType === 'adfs' || (settings.authTypes || []).includes('adfs'))) {
        initPromise.push(firebaseApp.auth().signInWithCustomToken(x[1]).then(u => {
          console.log('main.js:signInWithCustomToken:', user, u)
          if (u && u.user) {
            return u.user.getIdTokenResult().then(
              (idTokenResult) => {
                console.log('idTokenResult:', idTokenResult)
                if (idTokenResult && idTokenResult.claims && idTokenResult.claims.unavailable) {
                  return false
                }
              })
          } else {
            return u
          }
        }))
      }
      return f
    })
    console.log('Flg Cookie:', cf, c)
    if (cf) {
      let nc = document.cookie.split(';').map(x => { return x.trim().split('=') }).filter(x => { return x[0] !== 'CustomToken1on1navi' }).map(x => { return x.join('=') }).join('; ')
      console.log('New Cookie: ', nc)
      document.cookie = nc
    }
  }

  Promise.all(initPromise).then(init => {
    console.log('main.js:initPromise->then:start', { init, user, app })
    if (!app) {
      app = new Vue({
        mounted () {
          console.log('Vue mounted.')
          console.log(store.state)
        },
        el: '#app',
        i18n: i18n,
        liteMode: liteMode,
        routePath: routePath,
        routeRegistPath: routeRegistPath,
        onFocus: onFocus,
        progress: progress,
        content1on1: content1on1,
        about: about,
        licenseAgreement: licenseAgreement,
        store,
        router,
        components: { App },
        template: '<App/>',
        created () {
          console.log('Vue created.')
          window.addEventListener('focus', function () {
            store.dispatch('onFocus')
          })
        }
      })
    }
    console.log('main.js:initPromise->then:end', user, app)
  })
})



// WEBPACK FOOTER //
// ./src/main.js